import { createSystemOpportunityName } from '@user/components/Opportunities/OpportunityName/functions'
import { ILeadOppProduct } from '.'
import { IOpportunity, IOpportunityDetail } from '../opportunity'
import { LeadOppProductOrderInput } from './typings'

export const updateOppName = (
  entityId: number,
  input: LeadOppProductOrderInput,
  opportunityDetail: IOpportunityDetail | null,
  opportunity: IOpportunity | undefined,
  currentServices: ILeadOppProduct[],
) => {
  const newServices = currentServices
    .map((obj) => {
      return {
        ...obj,
        sortOrder: getProductOrder(obj, input),
      }
    })
    .sort((a, b) => a.sortOrder - b.sortOrder)
  const newOppName: string = createSystemOpportunityName(newServices)

  const nameToCompare = opportunity
    ? opportunity.opportunityName
    : opportunityDetail?.opportunityName
  return nameToCompare !== newOppName
    ? {
        id: entityId,
        name: newOppName,
        useSystemName: true,
      }
    : null
}

function getProductOrder(
  obj: ILeadOppProduct,
  input: LeadOppProductOrderInput,
) {
  const existingElement = input.leadOppProductOrders.find((x) => x.id == obj.id)
  return existingElement ? existingElement.order : 0
}
